module.exports = __webpack_public_path__ + "img/listing-inactive.5e254d9a.svg";